var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloud = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.954,
    height: 25.19,
    viewBox: "0 0 15.954 25.19",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Action",
    transform: "translate(-3.166 -280.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(3.166 280.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M696.058,482.069a6.714,6.714,0,0,0-1.909,13.211v1.947a2.929,2.929,0,0,0-2.1-.888h-.42a.42.42,0,0,0-.4.553,8.911,8.911,0,0,1,.4,2.386V503.9a3.36,3.36,0,0,0,3.359,3.359h1.679v-.84h-1.679a2.5,2.5,0,0,1-2.519-2.519v-4.618a7.958,7.958,0,0,0-.285-2.072,2.078,2.078,0,0,1,1.964,2.072v2.1h.84V489.622a.84.84,0,0,1,1.679,0v8.4h.84V495.5a.84.84,0,1,1,1.679,0v3.359h.84V496.34a.84.84,0,0,1,1.679,0V499.7h.84v-2.519a.84.84,0,1,1,1.679,0v8.4a.833.833,0,0,1-.84.84v.84a1.686,1.686,0,0,0,1.679-1.679v-8.4a1.686,1.686,0,0,0-1.679-1.679,1.668,1.668,0,0,1-2.519-.84.686.686,0,0,1-1.3-.3,6.716,6.716,0,0,0-3.512-12.291Zm-.027.838a5.875,5.875,0,0,1,2.721,10.969,1.589,1.589,0,0,0-1.245.18v-1.429a4.2,4.2,0,1,0-3.359,0v1.785a5.879,5.879,0,0,1,1.882-11.507Z",
    transform: "translate(-689.111 -482.065)",
    fill: "#e20074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M694.664,484.183a3.357,3.357,0,0,1,1.6,6.265V488.38a1.679,1.679,0,0,0-3.359,0v2.066a3.357,3.357,0,0,1,1.756-6.263Z",
    transform: "translate(-687.869 -480.823)",
    fill: "#e20074"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cloud.dd081a9951f02c5b5d659163134e000e.svg";